(function () {
  'use strict';
  if (window.PesadoCartFitWarning) return;
  var configNode = document.getElementById('pesado-cart-fit-config');
  if (!configNode || !window.PesadoCartFitEngine) return;
  var config;
  try { config = JSON.parse(configNode.textContent); } catch (error) { return; }
  var targets = { '189357883699': { channel: 'v1_2_preview', role: 'unpublished' }, '187483062579': { channel: 'live', role: 'main' } };
  var target = targets[String(config.themeId)];
  if (!target) return;
  var prefix = 'Fit confirmation', formSelector = 'form[action*="/cart"]';
  var engine = window.PesadoCartFitEngine, modal = document.getElementById('pesado-cart-fit-dialog');
  if (!modal) return;
  var ui = {};
  ['title', 'description', 'items', 'question', 'note', 'review', 'continue', 'status'].forEach(function (name) { ui[name] = modal.querySelector('[data-fit-' + name + ']'); });
  var loading = document.getElementById('pesado-cart-fit-loading');
  var content = modal.querySelector('.pesado-fit__content');
  var knownKeys = new Set(Object.keys(config.initialAttributes || {}).filter(function (key) { return key.indexOf(prefix) === 0; }));
  var blank = {}, fields = {}, intent = null, pending = false, permit = null, dialogState = null, payload = null, loadError = null, loadingPromise = null, savedOverflow = null;
  var expectedChanges = new Map();
  var metrics = { loadMs: null, evaluateMs: null, saveMs: null, coverage: null };
  function t(key) {
    var decoder = document.createElement('textarea');
    decoder.innerHTML = String(config.text[key] || key);
    return decoder.value;
  }
  function route(file) { return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/') + file; }
  function isFitKey(key) { return key.indexOf(prefix) === 0; }
  function learn(cart) { Object.keys(cart.attributes || {}).filter(isFitKey).forEach(function (key) { knownKeys.add(key); }); }
  function syncFields(values) {
    fields = values || {};
    Object.keys(fields).forEach(function (key) { knownKeys.add(key); });
    document.querySelectorAll(formSelector).forEach(function (form) {
      if (!form.querySelector('[name="checkout"], [data-agree-btn]')) return;
      knownKeys.forEach(function (key) {
        var input = Array.from(form.querySelectorAll('[data-pesado-fit-attribute]')).find(function (node) { return node.dataset.pesadoFitAttribute === key; });
        if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.dataset.pesadoFitAttribute = key; input.name = 'attributes[' + key + ']'; form.appendChild(input); }
        input.value = fields[key] || '';
      });
    });
  }
  function clearValues() { var values = {}; knownKeys.forEach(function (key) { values[key] = ''; }); return values; }
  async function request(file, options) {
    var controller = new AbortController(), timer = setTimeout(function () { controller.abort(); }, 7000);
    try {
      var response = await fetch(route(file), Object.assign({ credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: controller.signal }, options || {}));
      if (!response.ok) throw new Error('Cart request failed');
      return await response.json();
    } finally { clearTimeout(timer); }
  }
  async function digest(value) {
    if (!window.crypto || !window.crypto.subtle) throw new Error('Integrity verification unavailable');
    var bytes = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(value));
    return Array.from(new Uint8Array(bytes)).map(function (byte) { return byte.toString(16).padStart(2, '0'); }).join('');
  }
  function bounded(promise, ms) {
    return new Promise(function (resolve, reject) {
      var timer = setTimeout(function () { reject(new Error('Manager data did not load in time')); }, ms);
      Promise.resolve(promise).then(function (value) { clearTimeout(timer); resolve(value); }, function (error) { clearTimeout(timer); reject(error); });
    });
  }
  function loadRules(retry) {
    if (loadingPromise && !retry) return loadingPromise;
    var started = performance.now();
    loadError = null;
    loadingPromise = (async function () {
      var controller = new AbortController(), timer = setTimeout(function () { controller.abort(); }, 5000);
      try {
        var expectedChecksum = config.checksum, publishedSource = null;
        var rulesResponse = (async function () {
          var url = config.rulesUrl;
          if (config.managerManifestUrl) {
            var manifestResponse = await fetch(config.managerManifestUrl, { credentials: 'omit', cache: 'no-store', signal: controller.signal });
            if (!manifestResponse.ok) throw new Error('Manager cart rules publication unavailable');
            var manifest = await manifestResponse.json(), fileUrl = new URL(manifest.url);
            if (manifest.schemaVersion !== 1 || manifest.channel !== target.channel || String(manifest.targetTheme.id) !== String(config.themeId) || manifest.targetTheme.role !== target.role || fileUrl.protocol !== 'https:' || fileUrl.hostname !== 'cdn.shopify.com' || !/^[a-f\d]{64}$/.test(manifest.checksum)) throw new Error('Manager cart rules target mismatch');
            url = manifest.url; expectedChecksum = manifest.checksum; publishedSource = manifest.sourcePublication;
          }
          return fetch(url, { credentials: 'omit', cache: 'force-cache', signal: controller.signal });
        })();
        var readyAndResponse = await Promise.all([rulesResponse, bounded(window.PesadoCompatibilityReady, 3500)]);
        var response = readyAndResponse[0];
        if (!response.ok) throw new Error('Rules could not be loaded');
        var candidate = await response.json();
        if (candidate.schemaVersion !== 1 || candidate.channel !== target.channel || String(candidate.targetTheme.id) !== String(config.themeId) || candidate.targetTheme.role !== target.role) throw new Error('Rules target mismatch');
        if (candidate.checksum !== expectedChecksum || await digest(JSON.stringify(candidate.rules)) !== expectedChecksum) throw new Error('Rules integrity mismatch');
        if (publishedSource && (candidate.sourcePublication.version !== publishedSource.version || candidate.sourcePublication.checksum !== publishedSource.checksum)) throw new Error('Rules source mismatch');
        var manager = window.PesadoCompatibilityManagerConfig;
        if (!manager || manager.version !== candidate.sourcePublication.version || manager.checksum !== candidate.sourcePublication.checksum) throw new Error('Manager version mismatch');
        payload = candidate; loadError = null; metrics.loadMs = Math.round(performance.now() - started); configNode.dataset.fitLoadMs = String(metrics.loadMs); configNode.dataset.fitRulesRevision = candidate.rules.revision; configNode.dataset.fitRulesChecksum = candidate.checksum; return payload;
      } finally { clearTimeout(timer); }
    })();
    loadingPromise.catch(function (error) { loadError = error; });
    return loadingPromise;
  }
  function setBusy(value) {
    pending = value; loading.hidden = !value;
    if (intent && intent.button && intent.button.isConnected) intent.button.setAttribute('aria-busy', String(value));
  }
  function closeModal() {
    modal.hidden = true; modal.setAttribute('aria-hidden', 'true');
    if (savedOverflow !== null) { document.body.style.overflow = savedOverflow; savedOverflow = null; }
  }
  function adjustPreviewInset() {
    var bar = document.querySelector('iframe[src*="/preview-bar/"]');
    var rect = bar && bar.getBoundingClientRect();
    if (rect && rect.top <= 0 && bar.parentElement) rect = bar.parentElement.getBoundingClientRect();
    var height = rect && rect.height > 0 && rect.bottom >= window.innerHeight - 2 && rect.top > window.innerHeight / 2 ? window.innerHeight - rect.top : 0;
    modal.style.setProperty('--fit-preview-bar-height', Math.max(0, height) + 'px');
  }
  function openModal(state) {
    dialogState = state;
    ui.title.textContent = state.error ? t('errorTitle') : t('title');
    ui.description.textContent = state.error ? t(state.error === 'save' ? 'saveError' : 'loadError') : state.message;
    ui.items.replaceChildren();
    (state.result ? state.result.items : []).forEach(function (item) {
      var li = document.createElement('li'), name = document.createElement('span'), size = document.createElement('span');
      li.className = 'pesado-fit__item'; name.className = 'pesado-fit__name'; size.className = 'pesado-fit__size';
      name.textContent = item.label; size.textContent = item.size;
      var detail = document.createElement('small');
      detail.textContent = t('quantity') + ': ' + item.quantity;
      if (item.productType === 'bundle' && item.components.length) detail.textContent += ' · ' + t('includes') + ': ' + item.components.filter(function (part) { return part.fitFamilies.length || part.connections?.length || Object.keys(part.dimensions || {}).length; }).map(function (part) { return (part.quantity > 1 ? part.quantity + ' × ' : '') + part.label + ' (' + part.commercialSize + ')'; }).join(', ');
      name.appendChild(detail); li.append(name, size); ui.items.appendChild(li);
    });
    ui.items.hidden = !state.result || !state.result.items.length;
    ui.question.textContent = state.error ? t('errorQuestion') : t('question');
    ui.note.textContent = state.error ? t('errorNote') : t('note');
    ui.review.textContent = t('review'); ui.continue.textContent = state.error ? t('continueUnrecorded') : t('continue');
    ui.review.disabled = false; ui.continue.disabled = false; ui.status.textContent = '';
    savedOverflow = savedOverflow === null ? document.body.style.overflow : savedOverflow;
    adjustPreviewInset();
    document.body.style.overflow = 'hidden'; modal.hidden = false; modal.setAttribute('aria-hidden', 'false');
    if (content) content.scrollTop = 0;
    ui.review.focus({ preventScroll: true });
  }
  function currentForm() {
    if (intent && intent.form && intent.form.isConnected) return intent.form;
    var context = intent && intent.context;
    var terms = context && document.querySelector('[data-pesado-terms][data-terms-context="' + context + '"]');
    return terms ? terms.closest('form') : document.querySelector(formSelector + ':has([name="checkout"])');
  }
  function termsReady(form) { return !form.querySelector('[data-pesado-terms]') || Boolean(window.PesadoTermsAcceptance && window.PesadoTermsAcceptance.isReady()); }
  function resume(unrecorded) {
    var form = currentForm();
    if (!form) { intent = null; return; }
    syncFields(fields);
    var button = form.querySelector('[name="checkout"], [data-agree-btn]');
    if (!button) { intent = null; return; }
    closeModal(); setBusy(false);
    if (!termsReady(form)) { intent = null; button.click(); return; }
    // An explicit failure continuation posts blank confirmation fields natively,
    // so an unavailable Ajax endpoint cannot leave an older acceptance on the order.
    if (unrecorded) {
      var submitter = document.createElement('input'); submitter.type = 'hidden'; submitter.name = 'checkout'; submitter.value = 'Checkout'; form.appendChild(submitter);
      HTMLFormElement.prototype.submit.call(form); intent = null; return;
    }
    permit = { form: form, expires: Date.now() + 2000 };
    button.click();
    setTimeout(function () { permit = null; }, 2100);
    intent = null;
  }
  async function currentCart() {
    var deadline = Date.now() + 6500;
    for (;;) {
      var cart = await request('cart.js'); learn(cart);
      var form = currentForm(), inputs = form ? Array.from(form.querySelectorAll('[data-quantity-value][data-id]')) : [];
      var mismatch = inputs.some(function (input) {
        var line = cart.items.find(function (item) { return item.key === input.dataset.id; });
        return line && Number(input.value) !== line.quantity;
      });
      expectedChanges.forEach(function (quantity, key) {
        var line = cart.items.find(function (item) { return item.key === key; });
        if ((line ? line.quantity : 0) === quantity) expectedChanges.delete(key);
        else mismatch = true;
      });
      if (!mismatch) return cart;
      if (Date.now() >= deadline) throw new Error('Cart quantity update has not finished');
      await new Promise(function (resolve) { setTimeout(resolve, 150); });
    }
  }
  function analyze(cart) { var started = performance.now(), result = engine.evaluate(cart, payload.rules); metrics.evaluateMs = performance.now() - started; metrics.coverage = result.status; configNode.dataset.fitEvaluateMs = String(metrics.evaluateMs); configNode.dataset.fitCoverage = result.status; return result; }
  function displayedText(result) {
    var messages = Array.from(new Set(result.conflicts.map(function (conflict) { return conflict.message; }).filter(Boolean)));
    return { title: t('title'), message: messages.join(' ') || t('message'), question: t('question'), note: t('note'), review: t('review'), confirm: t('continue') };
  }
  async function compositionKey(result) { return digest(JSON.stringify([payload.rules.revision, payload.checksum, result.composition, displayedText(result)])); }
  async function updateAttributes(values) {
    var cart = await request('cart/update.js', { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: values }) });
    Object.keys(values).forEach(function (key) { if (String((cart.attributes || {})[key] || '') !== values[key]) throw new Error('Acceptance write was not confirmed'); });
    learn(cart); return cart;
  }
  async function inspect() {
    try {
      await loadRules(Boolean(loadError));
      var cart = await currentCart(), result = analyze(cart), key = await compositionKey(result);
      syncFields(blank);
      var attributes = cart.attributes || {};
      if (result.conflicts.length && attributes[prefix + ' composition'] === key && attributes[prefix] === 'YES' && attributes[prefix + ' rules'] === payload.rules.revision + ':' + payload.checksum) {
        var accepted = {}; Object.keys(attributes).filter(isFitKey).forEach(function (name) { accepted[name] = attributes[name]; }); syncFields(accepted); resume(); return;
      }
      if (Object.keys(attributes).some(function (name) { return isFitKey(name) && attributes[name]; })) await updateAttributes(clearValues());
      if (!result.conflicts.length) { resume(); return; }
      setBusy(false);
      openModal({ cart: cart, result: result, key: key, message: displayedText(result).message });
    } catch (error) { syncFields(blank); setBusy(false); openModal({ error: 'load' }); }
  }
  async function confirm() {
    if (pending || !intent || !dialogState) return;
    var state = dialogState;
    if (state.error) { syncFields(blank); resume(true); return; }
    setBusy(true); ui.review.disabled = true; ui.continue.disabled = true; ui.status.textContent = t('saving');
    var started = performance.now();
    try {
      var cart = await currentCart(), result = analyze(cart), key = await compositionKey(result);
      if (key !== state.key) { setBusy(false); await inspect(); return; }
      var recordItems = result.items.map(function (item) {
        var copy = Object.assign({}, item);
        copy.components = item.components.map(function (part) { return { id: part.id, label: part.label, quantity: part.quantity, variantId: part.variantId, sku: part.sku, productType: part.productType, commercialSize: part.commercialSize, fitFamilies: part.fitFamilies, dimensions: part.dimensions, connections: part.connections }; });
        return copy;
      });
      var record = { accepted: true, at: new Date().toISOString(), rules: payload.rules.revision, rulesChecksum: payload.checksum, sourcePublication: payload.sourcePublication, composition: key, notice: state.message, displayedText: displayedText(result), conflicts: result.conflicts, items: recordItems, unknownVariantIds: result.unknownVariantIds };
      var serialized = Array.from(JSON.stringify(record));
      if (serialized.length > 16000) throw new Error('Confirmation exceeds the supported record size');
      var values = clearValues(); values[prefix] = 'YES'; values[prefix + ' at'] = record.at; values[prefix + ' rules'] = record.rules + ':' + record.rulesChecksum; values[prefix + ' composition'] = key; values[prefix + ' notice'] = state.message;
      for (var index = 0; index < serialized.length; index += 200) values[prefix + ' details ' + String(1 + index / 200).padStart(2, '0')] = serialized.slice(index, index + 200).join('');
      values[prefix + ' details count'] = String(Math.ceil(serialized.length / 200));
      var saved = await updateAttributes(values), after = analyze(saved);
      if (await compositionKey(after) !== key) { syncFields(blank); await updateAttributes(clearValues()); setBusy(false); await inspect(); return; }
      metrics.saveMs = Math.round(performance.now() - started); configNode.dataset.fitSaveMs = String(metrics.saveMs); syncFields(values); resume();
    } catch (error) { syncFields(blank); setBusy(false); openModal({ error: 'save', result: state.result, message: state.message }); }
  }
  function guard(event, form, button) {
    if (!form || !button || !button.matches('[name="checkout"], [data-agree-btn]')) return false;
    if (permit && permit.form === form && permit.expires >= Date.now()) { if (event.type === 'submit') permit = null; return false; }
    event.preventDefault(); event.stopImmediatePropagation();
    if (pending || !modal.hidden) return true;
    intent = { form: form, button: button, context: (form.querySelector('[data-pesado-terms]') || {}).dataset?.termsContext || '' };
    setBusy(true); inspect(); return true;
  }
  ui.review.addEventListener('click', function () { if (pending) return; closeModal(); var button = intent && intent.button; intent = null; if (button && button.isConnected) button.focus({ preventScroll: true }); });
  ui.continue.addEventListener('click', confirm);
  modal.addEventListener('click', function (event) { if (event.target === modal && !pending) ui.review.click(); });
  document.addEventListener('keydown', function (event) {
    if (modal.hidden) return;
    if (event.key === 'Escape') { event.preventDefault(); event.stopImmediatePropagation(); if (!pending) ui.review.click(); }
    if (event.key === 'Tab') {
      var available = [content, ui.review, ui.continue].filter(function (element) { return element && !element.disabled; });
      if (!available.length) { event.preventDefault(); return; }
      if (event.shiftKey && document.activeElement === available[0]) { event.preventDefault(); available[available.length - 1].focus(); }
      else if (!event.shiftKey && document.activeElement === available[available.length - 1]) { event.preventDefault(); available[0].focus(); }
    }
  }, true);
  window.addEventListener('resize', function () { if (!modal.hidden) adjustPreviewInset(); });
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[name="checkout"], [data-agree-btn]');
    var form = button && button.closest(formSelector);
    if (form && !form.querySelector('[data-pesado-terms]')) guard(event, form, button);
  }, true);
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches(formSelector) || form.querySelector('[data-pesado-terms]')) return;
    var button = event.submitter || form.querySelector('[name="checkout"], [data-agree-btn]');
    if (button) guard(event, form, button);
  }, true);
  function invalidateVisibleAcceptance(event) {
    var target = event.target.closest && event.target.closest('[data-quantity-value], [data-quantity-selector], [data-cart-remove], [data-action-quickshop]');
    if (target && target.closest(formSelector)) {
      var input = target.matches('[data-quantity-value]') ? target : target.closest('[data-quantity-wrapper]')?.querySelector('[data-quantity-value]');
      if (target.matches('[data-cart-remove]')) expectedChanges.set(target.dataset.id, 0);
      else if (input) {
        var quantity = Number(input.value), step = Number(input.step) || 1;
        if (event.type === 'click' && target.matches('[data-increase-qty]')) quantity += step;
        if (event.type === 'click' && target.matches('[data-decrease-qty]')) quantity = Math.max(0, quantity - step);
        expectedChanges.set(input.dataset.id, quantity);
      }
      permit = null; syncFields(blank);
    }
  }
  document.addEventListener('change', invalidateVisibleAcceptance, true);
  document.addEventListener('click', invalidateVisibleAcceptance, true);
  window.PesadoCartFitWarning = {
    guard: guard, refresh: function () { syncFields(fields); }, metrics: metrics,
    ready: function () { return loadRules(Boolean(loadError)); },
    evaluate: function (cart) { if (!payload) throw new Error('Compatibility rules are not ready.'); return engine.evaluate(cart, payload.rules); },
    fitSensitive: function (variantId) { return !!payload && engine.fitSensitive(payload.rules.profiles.find(function (profile) { return profile.verified && profile.variantId === engine.variantId(variantId); })); },
    canRecommend: function (cart, items) { return !!payload && engine.canRecommend(cart, items, payload.rules); },
    filterProducts: async function (products) {
      await loadRules(Boolean(loadError));
      var cart = await request('cart.js?_pesado_fit=' + Date.now());
      return products.map(function (product) { return Object.assign({}, product, { variants: product.variants.filter(function (variant) { return engine.canRecommend(cart, [{id:variant.id,quantity:1}], payload.rules); }) }); }).filter(function (product) { return product.variants.some(function (variant) { return variant.available; }); });
    },
    assertAdd: async function (items) {
      await loadRules(Boolean(loadError));
      var cart = await request('cart.js?_pesado_fit=' + Date.now());
      if (!engine.canRecommend(cart, items, payload.rules)) {
        var error = new Error('Your cart has changed. Review product compatibility and try again.'); error.name = 'CartFitConflict'; throw error;
      }
      return cart;
    },
    coverage: 'Ordinary cart form checkout only; accelerated wallets, direct checkout links and product Buy now are not certified.'
  };
  document.dispatchEvent(new CustomEvent('pesado:cart-fit-ready'));
  syncFields(blank); loadRules(false);
  new MutationObserver(function (records) {
    if (records.some(function (record) { return Array.from(record.addedNodes).some(function (node) { return node.nodeType === 1 && (node.matches(formSelector) || node.querySelector(formSelector)); }); })) syncFields(fields);
  }).observe(document.body, { childList: true, subtree: true });
})();
